import * as types from './actionTypes';  
import stocktwitsAccountApi from '../api/stockTwitsApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';

export function doStocktwitsAccount(data) {
  return {
    type: types.DO_STOCKTWITS_ACCOUNT, 
    data
  };
}

export function doStocktwitsAccountRes(data) {  
  return {
    type: types.DO_STOCKTWITS_ACCOUNT_RES, 
    data
  };
}

export function stocktwits_account(data) {
  const TOKEN = getItem('auth_token');
  if(TOKEN){
    return function(dispatch) {
      stocktwitsAccountApi.doStocktwitsAccount(data).then(res => {
        dispatch(doStocktwitsAccountRes(res));
      }).catch(error => {
        return error
      });
    };
  }else{
    logout()
  }
}